var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sitemap"},[_c('sitemap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }